export function extractDate(dateTimeString = "") {
    if (dateTimeString == "" || dateTimeString == null || dateTimeString == undefined) {
        return "";
    } else {
        return dateTimeString.split('T')[0];
    }
}
